import { useEffect, useState } from 'react'

import { LogErrors } from './../../../utilities/LogErrors'
import { useFloatMessage, MESSAGE_TYPE } from './../../Providers/FloatMessage'


//     const fallbackCopy = (text) => {
//     const textarea = document.createElement('textarea')
//     textarea.value = text
//     textarea.style.position = 'fixed' // Evita scroll
//     document.body.appendChild(textarea)
//     textarea.focus()
//     textarea.select()
//     try {
//         document.execCommand('copy')
//         setCopiedCode(true)
//     } catch (error) {
//         setErrorMessage('No se pudo copiar el texto.')
//     }
//     document.body.removeChild(textarea)
// }

// navigator.clipboard.writeText(accessCode)
//     .then(() => setCopiedCode(true))
//     .catch(() => fallbackCopy(accessCode))


//const [copiedCode,setCopiedCode] = useState(false)

const AccessCode = ({ accessCode, setShowModal, description }) => {
    const { showMessage } = useFloatMessage()

    const [errorMessage,setErrorMessage] = useState(null)
    const [copyState, setCopyState] = useState('initial') // 'initial' | 'copied' | 'again'


    const CopyAccessCode = () => {
        try {
            setErrorMessage(null)

            if (accessCode) {
                navigator.clipboard.writeText(accessCode)

                showMessage({
                    type: MESSAGE_TYPE.SUCCESS,
                    text: `Código Ztudia copiado exitosamente al portapapeles`
                })

                setCopyState('copied')

                setTimeout(() => {
                    setCopyState('again')
                }, 1000)
            } else {
                setErrorMessage('No ha sido posible copiar el Código Ztudia. Inténtalo nuevamente o intenta copiarlo manualmente.')
            }
        } catch (error) {
            LogErrors('NextStepButton - Group', 'No ha sido posible copiar el Código Ztudia. Inténtalo nuevamente o intenta copiarlo manualmente. Error:' + error)
            setErrorMessage('No ha sido posible copiar el Código Ztudia. Inténtalo nuevamente o intenta copiarlo manualmente.')
        }
    }

    const CloseModal = async () => {
        try {
            await setShowModal(false)
        } catch (error) {
            
        }
    }

    // Detectar la tecla ESC para cerrar el modal
    useEffect(() => {
        const handleEscapeKey = async (event) => {
            if (event.key === 'Escape') {
                await CloseModal()
            }
        }
    
        window.addEventListener('keydown', handleEscapeKey)
    
        return () => {
            window.removeEventListener('keydown', handleEscapeKey)
        }
    }, [])


    return (
        <>
            <div className="cModal__Background" onClick={() => CloseModal()}></div>

            <div className="cModal__Container">
                {/* Contenido del modal */}
                <div className="cModal__Container__Content Modal__Layout--AccessCode">
                    <button type='button' className='Btn__Ztudia--DangerOutline cModal__Container__Content__CloseButton' onClick={() => CloseModal()}>X</button>

                    {/* Contenido del modal si solo es un mensaje de confirmación */}
                    <p className="cModal__Container__Content__Text">{description || "Comparte el código Ztudia a tus Ztudiantes para que se unan a tu grupo"}</p>
                    <p className="cModal__Container__Content__Text Modal__Layout--AccessCode__SpaceUp">Código Ztudia</p>
                    <p className="cModal__Container__Content__Text Modal__Layout--AccessCode__TextCode">{accessCode && accessCode}</p>

                    <div className='cModal__Container__Content__ContainerButtons'>
                        <button type='button' className='Btn__Ztudia--Primary Modal__Layout--AccessCode__Button' onClick={CopyAccessCode}>
                            {copyState === 'copied'
                                ? 'Código copiado'
                                : copyState === 'again'
                                ? 'Copiar código nuevamente'
                                : 'Copiar código'}
                        </button>
                    </div>
                    {errorMessage && errorMessage !== '' && ( <p className='cModal__Container__Content__Text--Error'>{errorMessage}</p> )}
                </div>
            </div>
        </>
    )
}

export { AccessCode };